import actionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setCurrentTenantAction = (currentTenant) => ({
  type: actionTypes.SET_CURRENT_TENANT,
  currentTenant,
});

export const setCrowdfundingInvestors = (crowdfunding = 'NO') => {
  return {
    type: actionTypes.SET_CROWDFUNDING_INVESTOR,
    payload: crowdfunding,
  };
};

export const setCrowdfundModal = (modal = false) => {
  return {
    type: actionTypes.SET_CROWDFUNDING_MODAL,
    payload: modal,
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions.js